// extracted by mini-css-extract-plugin
export default {"button":"yk-z","reviewSort":"zk-z"};